import React from 'react';
import SearchIcon from './image/search.svg';
import * as S from './EmptyState.style';
export const EmptyState = ({ title = '', message = '' }) => (React.createElement(S.EmptyState, null,
    React.createElement(S.EmptyStateImage, { src: SearchIcon, alt: title }),
    React.createElement(S.EmptyStateTitle, null, title),
    React.createElement(S.EmptyStateMessage, null, message)));
//# sourceMappingURL=EmptyState.js.map